import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import HomePage from './pages/HomePage';
import BOPPage from './pages/BOPPage';
import WorkersCompPage from './pages/WorkersCompPage';
import GeneralLiabilityPage from './pages/GeneralLiabilityPage';
import CommercialAutoPage from './pages/CommercialAutoPage';
import CommercialPropertyPage from './pages/CommercialPropertyPage';
import CyberLiabilityPage from './pages/CyberLiabilityPage';
import ToolsEquipmentPage from './pages/ToolsEquipmentPage';
import EPLIPage from './pages/EPLIPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import LocalizedSEOPage from './pages/LocalizedSEOPage';
import './App.css';

const cities = [
  'los-angeles', 'san-diego', 'san-jose', 'san-francisco', 'fresno',
  'sacramento', 'oakland', 'long-beach', 'anaheim', 'santa-ana'
];

const products = ['general-liability', 'bop', 'workers-compensation'];

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
        
        <motion.main
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/business-owners-policy" element={<BOPPage />} />
            <Route path="/workers-compensation" element={<WorkersCompPage />} />
            <Route path="/general-liability" element={<GeneralLiabilityPage />} />
            <Route path="/commercial-auto" element={<CommercialAutoPage />} />
            <Route path="/commercial-property" element={<CommercialPropertyPage />} />
            <Route path="/cyber-liability" element={<CyberLiabilityPage />} />
            <Route path="/tools-equipment" element={<ToolsEquipmentPage />} />
            <Route path="/epli" element={<EPLIPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            
            {/* Localized SEO Pages */}
            {cities.map(city =>
              products.map(product => (
                <Route
                  key={`${city}-${product}`}
                  path={`/${city}-${product}`}
                  element={<LocalizedSEOPage city={city} product={product} />}
                />
              ))
            )}
          </Routes>
        </motion.main>

        <Footer />
        
        {/* Chat Widget */}
        <ChatWidget />
      </div>
    </Router>
  );
}

export default App;